'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ProspectNewCtrl
 * @description
 * # ProspectNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ProspectNewCtrl', [
    '$scope', '$rootScope', 'Prospect', '$state', '$stateParams', 'GoogleApi', 'toaster', 'Client', function ($scope, $rootScope, Prospect, $state, $stateParams, GoogleApi, toaster, Client) {
    $rootScope.rootPath = {
      url: '',
      id: '',
    };
    var currentProspectName;
    var currentDriveId;
    $scope.clientHash = {}

    if($stateParams.prospectId) {
      Prospect.find($stateParams.prospectId).then(function(response) {
        $rootScope.isPicked = true;
        $scope.prospectHash = { 'prospect': response.data.prospect };
        currentProspectName = $scope.prospectHash.prospect.name;
        currentDriveId = $scope.prospectHash.prospect.drive_root_id;
        GoogleApi.getFolderName($scope.prospectHash.prospect.drive_root_id).then(function(response) {
          $rootScope.rootPath.name = response.result.name;
        }, function(error) {
          console.log(error);
        });

      }, function(error) {
        Prospect.error(error);
      });
    } else {
      $scope.prospectHash = {
        'prospect': {
          'name': '',
          'drive_root_id': '',
          'drive_root_url': ''
        }
      };
    }

    $scope.saveProspect = (() => {
      if($rootScope.rootPath.url !== '') {
        // jscs:disable
        $scope.prospectHash.prospect.drive_root_id = $rootScope.rootPath.id;
        $scope.prospectHash.prospect.drive_root_url = $rootScope.rootPath.url;
        // jscs:enable
      }
      Prospect.save($scope.prospectHash).then(function(response) {
        $rootScope.isPicked = true;
        if($scope.prospectHash.prospect.id === undefined || response.data.prospect.drive_root_id != currentDriveId) {
          $scope.prospectHash = response.data;
          GoogleApi.createClientFolderStructure("CV_" + $scope.prospectHash.prospect.name, $scope.prospectHash.prospect.drive_root_id, false).then((response) => {
            $scope.prospectHash.prospect.drive_root_id = response.client_root_id;
            $scope.prospectHash.prospect.drive_root_url = response.client_root_url;
            Prospect.save($scope.prospectHash).then(function(response) {
              //Inform of success?
              $scope.prospectHash = {
                'prospect': {
                  'name': '',
                  'drive_root_id': '',
                  'drive_root_url': ''
                }
              };
              $state.go('app.prospects.show', {prospectId: response.data.prospect.id});
            }, function(error) {
              Prospect.error(error);
            })
          }).catch((err) => {
            console.error(err);
          })
        } else { //Update
          if(response.data.prospect.name != currentProspectName) {
            GoogleApi.updateFolderName(response.data.prospect.drive_root_id, "CV_" + response.data.prospect.name).then(function() {
              //Succesfully updated folder name.
            }, function(error) {
              Prospect.error(error);
            });
            GoogleApi.renameChildClientFolders("CV_" + response.data.prospect.name, response.data.prospect.drive_root_id, "CV_" + currentProspectName).then(function() {
              toaster.pop('success', 'Drive Actualizado', 'Se actualizaron las carpetas del prospecto');
              $scope.prospectHash = {
                'prospect': {
                  'name': '',
                  'drive_root_id': '',
                  'drive_root_url': ''
                }
              };
              $state.go('app.prospects.show', {prospectId: response.data.prospect.id});
              //Succesfully update children.
            }, function(error) {
              Prospect.console.error(error);
            });
          }
        }
      }, function(error) {
        Prospect.error(error);
      });
    });

    $scope.selectFolder = function() {
      GoogleApi.pickerApiLoad(GoogleApi.getClientBaseFolderId(), 'folder');
    }

    $scope.isNew = function() {
      return true;
    }

    $scope.checkUrl = function() {
      if($rootScope.rootPath.url.includes("https://drive.google.com/drive/","folders/")) {
        var index = $rootScope.rootPath.url.indexOf("folders/") + 8
        $rootScope.rootPath.id = $rootScope.rootPath.url.substr(index)
      } else {
        var error = {
          status: 422,
          data: {
            errors: {
              base: ['Favor de verificar la ruta del proyecto.']
            }
          }
        }
        Prospect.error(error);
      }
    };

    $scope.convertToClient = function() {
      if(window.confirm(`¿Estas seguro que deseas convertir el prospecto ${$scope.prospectHash.prospect.name} a cliente?`)){
        Client.next_client_code().then((response) => {
          $scope.clientHash = {
            'client': {
              'name': $scope.prospectHash.prospect.name,
              'client_code': response.data.client_code,
              'email': '',
              'rfc': '',
              'complete_name': '',
              'was_prospect': true,
              'converted_to_prospect_by': $rootScope.myUser.id

            }
          }
          GoogleApi.moveProspectFoldersToClientFolders($scope.prospectHash.prospect.drive_root_id, $scope.prospectHash.prospect.name).then(function(response) {
            //Succesfully updated folder name.
            $scope.clientHash.client.drive_root_id = $scope.prospectHash.prospect.drive_root_id;
            $scope.clientHash.client.drive_root_url = $scope.prospectHash.prospect.drive_root_url;
            Client.save($scope.clientHash).then((response) => {
              $scope.clientHash = {
                'client': {
                  'name': '',
                  'client_code': '0',
                  'email': '',
                  'rfc': '',
                  'complete_name': '',
                  'was_prospect': false,
                  'converted_to_prospect_by': null
                }
              }
              Prospect.delete($scope.prospectHash.prospect.id).then(function(response) {
                toaster.pop('success', 'Prospecto Actualizado', 'Se convirtio el prospecto a cliente correctamente');
                GoogleApi.deleteFolders($scope.prospectHash.prospect.drive_root_id)
              }, function(error) {
                Prospect.error(error);
              });
              $state.go('app.clients.show', {clientId: response.data.client.id});
            }).catch((error) => {
              //Error while creating Client
              Client.error(error);
            });
          }, function(error) {
            GoogleApi.error(error);
          });
        })
      }
      $scope.clientHash = {
        'client': {
          'name': '',
          'client_code': '0',
          'email': '',
          'rfc': '',
          'complete_name': '',
          'was_prospect': false,
          'converted_to_prospect_by': null
        }
      }
    }
  }]);
